import { translate } from '@/plugins/i18n.js'
import ApiController from '@/services/ApiController'

class MessageHelper {
  constructor() {
    if (MessageHelper.Singleton) return

    MessageHelper.Singleton = this
  }

  async addMessage(
    message,
    icon = 'icon_svg_info',
    link = null,
    expiration = 5000
  ) {
    try {
      const { flashMessenger } = await _getModules()
      await flashMessenger.addMessage({
        expiration: expiration,
        message: translate(message),
        icon,
        link
      })
    } catch (error) {
      console.error(error)
    }
  }

  /**
   * @param {string} message
   * @param {string|null} link
   * @param {number} expiration
   * @param {Error|null} error - When present, sent to backend for NR (single channel, reliable). Failed requests remain visible in Network tab.
   * @param {string|null} [source] - Optional source for segmentation (e.g. 'checkout_opc', 'auth_register').
   * @param {string} [level] - Optional severity: emergency, alert, critical, error, warning, notice. Default: 'error'. Pass to override.
   */
  addErrorMessage(
    message,
    link = null,
    expiration = 5000,
    error = null,
    source = null,
    level = 'error'
  ) {
    if (error) {
      ApiController.logFrontendError(error, source || 'message_helper', level)
    } else {
      console.error(message)
    }
    this.addMessage(message, 'icon_svg_alert', link, expiration)
  }

  async destroyMessage() {
    try {
      const { flashMessenger } = await _getModules()
      await flashMessenger.removeMessage()
    } catch (error) {
      console.error(error)
    }
  }
}

const _getModules = (() => {
  let cache

  return async () => {
    if (cache) return cache

    const { useFlashMessengerStore } = await import('@/stores/flashMessenger')
    cache = { flashMessenger: useFlashMessengerStore() }
    return cache
  }
})()

export default new MessageHelper()
